const MenuIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="15" y1="0.5" x2="-2.68846e-10" y2="0.5" stroke="black" />
      <line
        x1="12.3913"
        y1="6.66517"
        x2="2.19341e-05"
        y2="6.66517"
        stroke="black"
      />
      <line
        x1="8.47827"
        y1="14.0634"
        x2="1.04898e-05"
        y2="14.0634"
        stroke="black"
      />
    </svg>
  );
};
export default MenuIcon;
